module.exports = __webpack_public_path__ + "img/LPSC.16957301.jpg";